import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { css } from 'styled-components';
import { marginAttributes, paddingAttributes, widthAttributes } from '../../system/attributes';
import { durationRegular } from '../../tokens';
import { getPropsBlocker } from '../../utils';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
import { reset } from '../../system/mixins';
var propertyList = {
  tag: true,
  primary: true,
  secondary: true,
  tertiary: true,
  danger: true,
  small: true,
  wide: true
};

var getRootBasicStyle = function getRootBasicStyle(_ref) {
  var theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    transition: background-color ", "ms ease,\n        border-color ", "ms ease, color ", "ms ease;\n    ", "\n"])), durationRegular, durationRegular, durationRegular, theme.componentOverrides.Button.Root.base);
};

var getRootDynamicVisualStyle = function getRootDynamicVisualStyle(_ref2) {
  var Button = _ref2.theme.componentOverrides.Button,
      secondary = _ref2.secondary,
      tertiary = _ref2.tertiary;

  if (secondary) {
    return Button.Root.secondary;
  }

  if (tertiary) {
    return Button.Root.tertiary;
  }

  return Button.Root.primary;
};

var getRootDynamicVisualDangerStyle = function getRootDynamicVisualDangerStyle(_ref3) {
  var Button = _ref3.theme.componentOverrides.Button,
      secondary = _ref3.secondary,
      tertiary = _ref3.tertiary,
      danger = _ref3.danger;

  if (!danger) {
    return '';
  }

  if (secondary) {
    return Button.Root.secondary__danger;
  }

  if (tertiary) {
    return Button.Root.tertiary__danger;
  }

  return Button.Root.primary__danger;
};

var getRootDynamicSizeStyle = function getRootDynamicSizeStyle(_ref4) {
  var Button = _ref4.theme.componentOverrides.Button,
      small = _ref4.small;
  return small ? Button.Root.small : '';
};

var Wrapper = function Wrapper(_ref5) {
  var children = _ref5.children,
      restProps = _objectWithoutProperties(_ref5, _excluded);

  return children(_objectSpread({}, restProps));
};

export var ButtonRoot = styled(Wrapper).withConfig(getPropsBlocker(propertyList))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    align-items: center;\n    appearance: none;\n    border: 1px solid transparent;\n    cursor: pointer;\n    display: inline-flex;\n    justify-content: center;\n    outline: none;\n    padding: 0;\n    position: relative;\n    text-align: center;\n    text-decoration: none;\n    letter-spacing: 0;\n    user-select: none;\n    vertical-align: middle;\n\n    &:hover, &:focus, &:disabled, &:active, &:visited {\n        text-decoration: none;\n        outline: none;\n    }\n    \n    &:disabled {\n        cursor: not-allowed;\n    }\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", ";\n    ", "\n    ", "\n    ", "\n"])), reset(), getRootBasicStyle, getRootDynamicVisualStyle, getRootDynamicSizeStyle, getRootDynamicVisualDangerStyle, getComponentOverride('Button'), marginAttributes, paddingAttributes, widthAttributes);